import { useEffect, useMemo, useState } from 'react'
import { twMerge } from 'tailwind-merge'

export type ContentBackground = 'glassmorphic' | 'transparent' | 'white'
export type ContentPosition = 'left' | 'center' | 'right'
export type ContentAlignment = 'left' | 'center' | 'right'

export const contentAlignmentMap = {
  center: 'items-center text-center',
  left: 'items-start text-left',
  right: 'items-end text-right',
} as const

export const contentBackgroundMap = {
  glassmorphic: 'bg-[#ffffff99] backdrop-blur-md backdrop-opacity-0',
  transparent: 'bg-transparent',
  white: 'bg-white',
} as const

export const contentPositionMap = {
  left: 'lg:ml-[10.8333dvw]',
  center: 'lg:mx-auto',
  right: 'lg:mr-[10.8333dvw]',
} as const

export function useContentBackground(contentBackground: ContentBackground) {
  const [animateBackdrop, setAnimateBackdrop] = useState(false)

  useEffect(() => {
    if (contentBackground === 'glassmorphic') {
      const timer = setTimeout(() => setAnimateBackdrop(true), 250)
      return () => clearTimeout(timer)
    }
  }, [contentBackground])

  const className = useMemo(
    () =>
      contentBackground === 'glassmorphic'
        ? twMerge(
            'bg-[#ffffff99] backdrop-blur-md transition-[backdrop-filter] duration-[1000ms] ease-in-out',
            animateBackdrop ? 'backdrop-opacity-100' : 'backdrop-opacity-0',
          )
        : contentBackgroundMap[contentBackground],
    [contentBackground, animateBackdrop],
  )

  return className
}
